import { SyntheticEvent } from 'react';
import { useGetAlternativeAuthMethods } from 'react-easyrocket';
import { SocialMediaLink } from './components/SocialMediaLink';
import { Skeletons } from 'src/components/Skeletons';
import classNames from 'classnames';
import { SeparatorAuthMethods } from '../SeparatorAuthMethods';

interface AlternativeAuthMethodsBlockProps {
  checkSubmitSocialLinks?: (e: SyntheticEvent) => void;
}

export const AlternativeAuthMethods = ({
  checkSubmitSocialLinks
}: AlternativeAuthMethodsBlockProps) => {
  const { alternativeAuthMethods, isLoading: loadingAlternativeAuthMethods } =
    useGetAlternativeAuthMethods();

  const allDisabled =
    !loadingAlternativeAuthMethods && alternativeAuthMethods.every((method) => !method.is_enabled);
  const isSmall =
    alternativeAuthMethods.reduce((acc, item) => {
      return item.is_enabled ? acc + 1 : acc;
    }, 0) > 2;

  if (allDisabled) return null;

  return (
    <div className="flex flex-col justify-center items-center w-full gap-1">
      {loadingAlternativeAuthMethods ? (
        <div className="w-full flex gap-2">
          <Skeletons className="w-full h-10 rounded-full" />
        </div>
      ) : (
        <>
          <div
            className={classNames(
              'w-full flex justify-center items-center gap-2',
              isSmall && 'flex-wrap'
            )}>
            {alternativeAuthMethods.map(
              (method, index) =>
                method.is_enabled && (
                  <SocialMediaLink
                    image={method.image}
                    onClick={checkSubmitSocialLinks}
                    name={method.name}
                    path={method.oauth_url}
                    isSmall={isSmall}
                    key={index}
                  />
                )
            )}
          </div>
          <SeparatorAuthMethods isLoading={loadingAlternativeAuthMethods} />
        </>
      )}
    </div>
  );
};
